import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type GetReportDataInput = {
  referralId: Scalars['String']['input'];
  referralSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportPdfUrlInput = {
  referralSessionId: Scalars['String']['input'];
};

export type PagedQuery = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  getReportData: ReportDataAndAssociatedReports;
  getReportPDFUrl?: Maybe<ReportPdfUrlData>;
};


export type QueryGetReportDataArgs = {
  input: GetReportDataInput;
};


export type QueryGetReportPdfUrlArgs = {
  input: GetReportPdfUrlInput;
};

export type Referral = {
  __typename?: 'Referral';
  id: Scalars['ID']['output'];
  service: Service;
};

export type ReferralSession = {
  __typename?: 'ReferralSession';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  referral: Referral;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportData = {
  __typename?: 'ReportData';
  activeReferralSessionExists: Scalars['Boolean']['output'];
  answers: Scalars['JSON']['output'];
  healthcareLookupPerformed: Scalars['Boolean']['output'];
  healthcareSystemLookupId?: Maybe<Scalars['String']['output']>;
  healthcareSystemPatientId?: Maybe<Scalars['String']['output']>;
  piSystemId: Scalars['String']['output'];
  reportShapeDefinition: Scalars['JSON']['output'];
  respondents?: Maybe<Array<RespondentStatus>>;
  surveys: Array<Survey>;
};

export type ReportDataAndAssociatedReports = {
  __typename?: 'ReportDataAndAssociatedReports';
  associatedReports: Array<ReferralSession>;
  reportData?: Maybe<ReportData>;
};

export type ReportPdfUrlData = {
  __typename?: 'ReportPDFUrlData';
  url: Scalars['String']['output'];
};

export type RespondentStatus = {
  __typename?: 'RespondentStatus';
  complete: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  respondentType: Scalars['String']['output'];
};

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Survey = {
  __typename?: 'Survey';
  code: Scalars['String']['output'];
  definition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  respondentType: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetReportDataQueryVariables = Exact<{
  input: GetReportDataInput;
}>;


export type GetReportDataQuery = { __typename?: 'Query', getReportData: { __typename?: 'ReportDataAndAssociatedReports', reportData?: { __typename?: 'ReportData', reportShapeDefinition: any, piSystemId: string, healthcareSystemLookupId?: string | null, healthcareSystemPatientId?: string | null, healthcareLookupPerformed: boolean, activeReferralSessionExists: boolean, answers: any, surveys: Array<{ __typename?: 'Survey', id: string, code: string, name: string, version: string, respondentType: string, definition: string }>, respondents?: Array<{ __typename?: 'RespondentStatus', respondentType: string, complete: boolean, completedAt?: any | null }> | null } | null, associatedReports: Array<{ __typename?: 'ReferralSession', id: string, updatedAt: any, completedAt?: any | null, status: string, referral: { __typename?: 'Referral', id: string, service: { __typename?: 'Service', code: string, description: string } } }> } };

export type GetReportPdfUrlQueryVariables = Exact<{
  input: GetReportPdfUrlInput;
}>;


export type GetReportPdfUrlQuery = { __typename?: 'Query', getReportPDFUrl?: { __typename?: 'ReportPDFUrlData', url: string } | null };


export const GetReportDataDocument = gql`
    query GetReportData($input: GetReportDataInput!) {
  getReportData(input: $input) {
    reportData {
      reportShapeDefinition
      piSystemId
      healthcareSystemLookupId
      healthcareSystemPatientId
      healthcareLookupPerformed
      activeReferralSessionExists
      answers
      surveys {
        id
        code
        name
        version
        respondentType
        definition
      }
      respondents {
        respondentType
        complete
        completedAt
      }
    }
    associatedReports {
      id
      referral {
        id
        service {
          code
          description
        }
      }
      updatedAt
      completedAt
      status
    }
  }
}
    `;

export function useGetReportDataQuery(options: Omit<Urql.UseQueryArgs<GetReportDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReportDataQuery, GetReportDataQueryVariables>({ query: GetReportDataDocument, ...options });
};
export const GetReportPdfUrlDocument = gql`
    query GetReportPDFUrl($input: GetReportPDFUrlInput!) {
  getReportPDFUrl(input: $input) {
    url
  }
}
    `;

export function useGetReportPdfUrlQuery(options: Omit<Urql.UseQueryArgs<GetReportPdfUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReportPdfUrlQuery, GetReportPdfUrlQueryVariables>({ query: GetReportPdfUrlDocument, ...options });
};